/**
 * @fileOverview This file contains the implementation of the warehouse admon edit modal for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Diego Benitez Reyna
 */

import { TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';
import { trimValue } from '../../../utils/generalUtils';

const ModalUInventoryType = ({ data, show, onHide, refreshData }) => {
  const { editString, saveStr } = useTranslationHook();

  const [name, setName] = useState(data.name);
  const [description, setDescription] = useState(data.description);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimedName = trimValue(name);
    const trimedDescription = description ? trimValue(description) : null;

    try {
      const editRes = await customAxios.patch(
        `${GlobalVariables.getURL()}inventory/updateInventoryType/${data.id}`,
        {
          name: trimedName,
          description: trimedDescription,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );

      getToast({
        status: editRes.data.status,
        title: editRes.data.message,
      });

      handleClose();
    } catch (error) {
      console.log(error);
      if (error.response.data?.errors) {
        const errors = error.response.data?.errors;
        errors.forEach((err) => {
          getToast({ status: 'error', title: err.message });
        });
      } else {
        getToast({
          status: error.response.data.status,
          title: error.response.data.message,
        });
      }
    }
  };

  const handleClose = () => {
    resetFields();
    refreshData();
    onHide();
  };

  const resetFields = () => {
    setName('');
    setDescription('');
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {`${editString} Almacén`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='inventory-form' onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label='Nombre'
                type='text'
                value={name || ''}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label='Descripción'
                type='text'
                multiline
                rows={3}
                value={description || ''}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type='submit'
          form='inventory-form'
          className='save-modal-button'
        >
          {saveStr}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUInventoryType;
